/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from 'react'
import Cookies from 'universal-cookie'
import { ethers } from 'ethers'
import { useAccount } from 'wagmi'
import '../../App.css'
import TokenAbi from '../../config/TokenAbi.json'
import PresaleAbi from '../../config/PresaleAbi.json'
import Input from '../Input.tsx'
import { readContract, waitForTransactionReceipt, writeContract } from '@wagmi/core'
import ClipLoader from 'react-spinners/ClipLoader'
import { waitForTransaction } from '@wagmi/core'
import { useQueryParam, StringParam } from 'use-query-params'
import eth from '../../icons/eth.png'
import usdc from '../../icons/usdc.png'
import usdt from '../../icons/USDT.svg'
import Logo from '../../icons/logo-only.png'
import LogoHeader from '../../icons/logo-only.png'
import Web3 from 'web3'
import { toast } from 'react-hot-toast'
import rot13 from '../../utils/encode.ts'
import { config } from '../../config.jsx'
import { id } from 'ethers/lib/utils'
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { writeContracts } from 'viem/experimental';

import logo from '../../assets/landing/logo.svg'
import ethLogo from '../../assets/landing/ETH.svg'
import usdtLogo from '../../assets/landing/USDT.svg'
import cardLogo from '../../assets/landing/card.svg'
import favLogo from '../../assets/landing/favlogo.svg'
import cloud from '../../assets/landing/shape_cloud_1.svg'
import cloud2 from '../../assets/landing/shape_cloud_2.svg'
import rightTree from '../../assets/landing/shape_tree_1.png'
import leftTree from '../../assets/landing/shape_tree_1_1.png'
import frogLeft from '../../assets/landing/frog-1.svg'
import frogRight from '../../assets/landing/frog-2.svg'

const sourceOptions = [
  {
    icon: ethLogo,
    title: 'ETH',
    value: '',
    rate: ''
  },
  {
    icon: usdtLogo,
    title: 'USDT',
    value: '',
    rate: ''
  },
  {
    icon: cardLogo,
    title: 'CARD',
    value: '',
    rate: ''
  }
]

const Hero = () => {
  const [selectedOpt, setSelectedOpt] = useState(sourceOptions[0])

  const { address, isConnected } = useAccount()
  const [tokenAmount, setAmount] = useState(0)
  const [allowanceAmount, setAllowanceAmount] = useState(0)
  const [raisedAmount, setRaisedAmount] = useState(0)
  let [loading, setLoading] = useState(false)
  let [confirming, setConfirming] = useState(false)
  const PresaleAddress = '0x5584197Ce066aAbc11919aCe52B6DF5948b1e930'
  const usdcAddress = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'
  const usdtAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7'

  const [selectedToken, setSelectToken] = useState(0)
  const [selectedTokenName, setSelectedTokenName] = useState('ETH')
  const [outTokenAmount, setOutTokenAmount] = useState(0)
  let [accountBalance, setAccountBalance] = useState(0)

  const ETH_PROVIDER_URL = 'https://ethereum-rpc.publicnode.com/'
  let ETHweb3 = new Web3(new Web3.providers.HttpProvider(ETH_PROVIDER_URL))
  const [progress, setProgress] = useState('0%')
  const [presaleId, setPresaleId] = useState(null)
  const [totalAmount, setTotalAmount] = useState(0)
  const [tokenSoldAmount, setTokenSoldAmount] = useState(0)
  const [totalToknesToSell, setTotalTokensToSell] = useState(0)
  const [currentPrice, setCurrentPrice] = useState(0)
  const [nextPrice, setNextPrice] = useState(0)
  const [presaleStatus, setPresaleStatus] = useState('null')
  const [claimable, setClaimable] = useState(false)
  const [claimableAmount, setClaimableAmount] = useState(0)
  const [totalRaisedAmount, setTotalRaisedAmount] = useState(0)
  const { open } = useWeb3Modal()

  // let [addressDatas] = useQueryParam('ref', StringParam)
  // let ref
  // if (addressDatas) {
  //   ref = addressDatas.split('/?ref=')[0]
  // }

  // const cookies = new Cookies()
  // if (ref) {
  //   if (Web3.utils.isAddress(rot13(ref))) {
  //     cookies.set('ref', ref)
  //   }
  // }
  // let refAddress
  // if (cookies.get('ref')) {
  //   if (Web3.utils.isAddress(rot13(cookies.get('ref')))) {
  //     refAddress = rot13(cookies.get('ref'))
  //   }
  // } else {
  //   refAddress = "0x0000000000000000000000000000000000000000"
  // }
  const BASE_URL = 'https://presale.lintelcoin.net'

  useEffect(() => {
    if (loading === true) {
      setTimeout(() => setLoading(false), 3000)
    }
  }, [loading])

  const onTokenAllowance = async () => {
    try {
      setConfirming(true);
      const hash = await writeContract(config, {
        address: usdtAddress,
        abi: TokenAbi,
        functionName: 'approve',
        args: [PresaleAddress, ETHweb3.utils.toBN(String(tokenAmount * 10 ** 6))],
      });
      const approveData = await waitForTransactionReceipt(config, { hash: hash });
      toast.success('Successfully approved');
      console.log('approveData', approveData);
      setConfirming(false);

      let allowance;
      allowance = await readContract(config, {
        address: usdtAddress,
        abi: TokenAbi,
        functionName: 'allowance',
        args: [address, PresaleAddress],
      });

      console.log('allowance', allowance);
      setAllowanceAmount(Number(allowance) / 10 ** 6);
    } catch (err) {
      toast.error("Failed to approve tokens.");
      console.error(err);
      setConfirming(false);
    }
  };

  const onTokenDeposit = async () => {
    try {
      setConfirming(true)
      let deposit;
      if (selectedToken === 0) {
        deposit = await writeContract(config, {
          address: PresaleAddress,
          abi: PresaleAbi,
          functionName: 'buyWithEth',
          value: ETHweb3.utils.toWei(String(tokenAmount), 'ether'),
          args: []
        });
      } else {
        deposit = await writeContract(config, {
          address: PresaleAddress,
          abi: PresaleAbi,
          functionName: 'buyWithUSDT',
          args: [ETHweb3.utils.toBN(String(tokenAmount * 10 ** 6))]
        });
      }
      const depositData = await waitForTransaction(config, {
        hash: deposit
      })
      // console.log('depositData', depositData)
      setTimeout(() => setConfirming(false), 3000)
      toast.success(
        `Successfully ${tokenAmount} ${selectedToken === 0 ? 'ETH' : selectedToken === 1 ? 'USDC' : 'USDT'
        } deposited`
      );
      const totalStages = await readContract(config, {
        address: PresaleAddress,
        abi: PresaleAbi,
        functionName: 'currentSale',
      });

      setPresaleId(totalStages);

      let totalRaised = 0;
      let totalSoldTokens = 0;

      for (let i = 0; i <= Number(totalStages); i++) {
        const Data = await readContract(config, {
          address: PresaleAddress,
          abi: PresaleAbi,
          functionName: 'presale',
          args: [i],
        });

        // let totalClaimable = ethers.BigNumber.from(0);

        totalRaised += Number(Data[7]);
        totalSoldTokens += Number(Data[4]);

        setRaisedAmount(totalRaised);
        setTokenSoldAmount(totalSoldTokens);

        const percent = (Number(tokenSoldAmount * 100) / totalToknesToSell).toFixed(3) + '%';
        setProgress(percent);

      }
    } catch (err) {
      // console.log(err);
      toast.error('There is a problem with your deposit. Please try again later');
      setConfirming(false);

    }
  };
  const onTokenClaim = async () => {
    try {
      setConfirming(true)
      let claim
      claim = await writeContract(config, {
        address: PresaleAddress,
        abi: PresaleAbi,
        functionName: 'claimAmount',
        args: [presaleId]
      });
      const claimData = await waitForTransaction(config, { hash: claim.hash });
      console.log('claimData', claimData);
      setTimeout(() => setConfirming(false), 3000);
      toast.success(`Successfully claimed`);

      const totalStages = await readContract(config, {
        address: PresaleAddress,
        abi: PresaleAbi,
        functionName: 'currentSale', // Replace with actual method name
        args: [presaleId],
      });

      let claimableAmount = 0;
      for (let i = 1; i <= Number(totalStages); i++) {
        const claimableData = await readContract(config, {
          address: PresaleAddress,
          abi: PresaleAbi,
          functionName: 'userClaimData',
          args: [address, i],
        });

        claimableAmount += (Number(claimableData[2] - claimableData[3] - claimableData[4])) / 10 ** 18;

        setClaimableAmount(claimableAmount);
      }
    }
    catch (err) {
      toast.error('There is a problem with your claim. Please try again later');
      setConfirming(false);
    }
  };

  const setMaxAmount = async () => {
    if (selectedToken === 0 && accountBalance > 0)
      accountBalance = accountBalance - 0.01
    setAmount(accountBalance);
  }

  useEffect(() => {
    const FetchData = async () => {
      try {
        if (address) {
          if (selectedToken === 0) {
            setSelectedTokenName('ETH')
            accountBalance = await ETHweb3.eth.getBalance(address)
            accountBalance = ETHweb3.utils.fromWei(accountBalance, 'ether')
            setAccountBalance(accountBalance)
          } else {
            setSelectedTokenName('USDT')
            const balance = await readContract(config, {
              address: usdtAddress,
              abi: TokenAbi,
              functionName: 'balanceOf',
              args: [address]
            });
            setAccountBalance(Number(balance) / 10 ** 6)
          }
        }
      } catch (e) {
        console.error(e)
      }
    };

    const FetchGlobalData = async () => {
      try {
        const totalStages = await readContract(config, {
          address: PresaleAddress,
          abi: PresaleAbi,
          functionName: 'currentSale',
        });
        setPresaleId(totalStages);

        let totalRaised = 0;
        let totalTokens = 0;
        let totalSoldTokens = 0;
        let raisedPerstage = 0;
        let totalTokenToSell = 0;

        for (let i = 0; i <= Number(totalStages); i++) {
          const data = await readContract(config, {
            address: PresaleAddress,
            abi: PresaleAbi,
            functionName: 'presale',
            args: [i],
          });

          // data indices assumed from your code: [2]=currentPrice, [3]=nextPrice, [4]=soldTokens, [5]=tokensToSell, [6]=totalAmount, [7]=raisedAmount, [8]=status, [9]=claimable
          totalRaised += Number(data[7]);
          totalTokens += Number(data[6]);
          totalSoldTokens += Number(data[4]);
          totalTokenToSell += Number(data[5]);
        }
        const overallRaised = await readContract(config, {
          address: PresaleAddress,
          abi: PresaleAbi,
          functionName: 'overalllRaised',
        });

        setTotalRaisedAmount(Number(overallRaised) / 10 ** 6);
        setRaisedAmount(totalRaised);
        setTotalAmount(totalTokens);
        setTokenSoldAmount(totalSoldTokens);
        setTotalTokensToSell(totalTokenToSell);

        // Assume latest stage is current
        const latestStageData = await readContract(config, {
          address: PresaleAddress,
          abi: PresaleAbi,
          functionName: 'presale',
          args: [totalStages],
        });

        // setTotalTokensToSell(Number(latestStageData[5]));
        setCurrentPrice(Number(latestStageData[2]) / 10 ** 18);
        setNextPrice(Number(latestStageData[3]) / 10 ** 18);
        setPresaleStatus(latestStageData[8]);
        setClaimable(latestStageData[9]);

        if (latestStageData[9] === true) {
          let claimableAmount = 0;
          for (let i = 1; i <= Number(totalStages); i++) {
            const claimableData = await readContract(config, {
              address: PresaleAddress,
              abi: PresaleAbi,
              functionName: 'userClaimData',
              args: [address, i],
            });

            claimableAmount += (Number(claimableData[2] - claimableData[3] - claimableData[4])) / 10 ** 18;

            setClaimableAmount(claimableAmount);
          }
        }
        FetchData();
      } catch (e) {
        console.error(e);
      }

    };

    if (presaleId == null) {
      FetchGlobalData();
    } else {
      FetchData();
    }
  }, [selectedToken, address]);

  useEffect(() => {
    const fetchProgress = async () => {
      try {
        const percent = (Number(((tokenSoldAmount) * 100) / totalToknesToSell));
        const prog = percent.toFixed(3) + '%'
        setProgress(prog)
      } catch (e) {
        console.error(e)
      }
    }
    if (Number(tokenSoldAmount) > 0) {
      fetchProgress()
    }
  }, [tokenSoldAmount, totalToknesToSell])

  useEffect(() => {
    const FetchData = async () => {
      try {
        let balance;
        if (selectedToken === 0) {
          balance = await readContract(config, {
            address: PresaleAddress,
            abi: PresaleAbi,
            functionName: 'ethToTokens',
            args: [presaleId, ETHweb3.utils.toWei(String(tokenAmount), 'ether')]
          });
        } else if (selectedToken === 1) {
          balance = await readContract(config, {
            address: PresaleAddress,
            abi: PresaleAbi,
            functionName: 'usdtToTokens',
            args: [presaleId, ETHweb3.utils.toBN(String(tokenAmount * 10 ** 6))]
          })
        } else {
          balance = await readContract(config, {
            address: PresaleAddress,
            abi: PresaleAbi,
            functionName: 'usdtToTokens',
            args: [presaleId, ETHweb3.utils.toBN(String(tokenAmount * 10 ** 6))]
          })
        }
        setOutTokenAmount((Number(balance) / 10 ** 18).toFixed(0))
      } catch (e) {
        console.error(e)
      }
    };
    if (tokenAmount > 0) {
      FetchData();
    } else {
      setOutTokenAmount('0');
    }
  }, [ETHweb3.utils, presaleId, selectedToken, tokenAmount]);

  useEffect(() => {
    if (tokenAmount > 0 && !confirming) {
       (async () => {
        try {
          let allowance;
          if (selectedToken === 1) {
            allowance = await readContract(config, {
              address: usdcAddress,
              abi: TokenAbi,
              functionName: 'allowance',
              args: [address, PresaleAddress]
            });
          } else if (selectedToken === 2) {
            allowance = await readContract(config, {
              address: usdtAddress,
              abi: TokenAbi,
              functionName: 'allowance',
              args: [address, PresaleAddress]
            });
          }
          setAllowanceAmount(Number(allowance) / 10 ** 6);
        } catch (e) {
          console.error(e);
        }
      })();
    }
  }, [address, selectedToken, tokenAmount, confirming]);

  const textRef = useRef(null);
  const [textWidth, setTextWidth] = useState(0);

  useEffect(() => {
    if (textRef.current) {
      setTextWidth(textRef.current.offsetWidth);
    }
  }, [raisedAmount]);

  const [copied, setCopied] = useState(false);

  const handleCopyReferral = () => {
    const referralLink = address
      ? `${BASE_URL}/?ref=${rot13(address)}`
      : `${BASE_URL}/?ref=`
    navigator.clipboard.writeText(referralLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    })
  };

  return (
    <div
      className="pb-[300px] md:pb-[100px] relative overflow-hidden z-0"
      style={{
        background: `linear-gradient(180deg, #c6f0e0 41.35%, #087238 100%)`
      }}
    >
      <div className=" px-3 md:px-6 text-center max-w-[1240px] w-full mx-auto font-sourGummy z-1">
        <h1 className="uppercase text-[46px] md:text-[90px] pt-6 pb-2 font-extrabold hero-text leading-tight text-black">
          The new born evm layer 2 machine: Little pepe
        </h1>
        <p className="max-w-[1032px] w-full mx-auto font-bold text-[15px] md:text-[32px]">
          Enter the new world order with LILPEPE, where the unstoppable force of
          memes meets their home in low cost, lighting fast layer 2 EVM protocol
          enabled by Little Pepe Chain.
        </p>

        <img
          src={cloud}
          alt="cloud"
          className="absolute left-0 top-[170px] md:top-[150px] w-[85px] md:w-auto z-[-1]"
        />
        <img
          src={cloud2}
          alt="cloud"
          className="absolute right-[0px] top-[159px] md:top-[180px] w-[119px] md:w-auto z-[-1]"
        />
        <img
          src={leftTree}
          alt="Left Tree"
          className="absolute left-[-20px] md:left-[0px] top-[350px] md:top-[280px] rotate-1 w-[200px] md:h-auto md:w-auto  z-[-1]"
        />

        <img
          src={rightTree}
          alt="Left Tree"
          className="absolute right-[-25px] md:right-[0px] top-[330px] md:top-[300px] rotate-1 w-[200px] md:h-auto md:w-auto  z-[-1]"
        />
        <img
          src={frogLeft}
          alt=""
          className="hidden md:block absolute left-[0px] top-[630px]  z-[-1]"
        />

        <img
          src={frogRight}
          alt=""
          className="absolute right-[50%] translate-x-[50%] md:translate-x-0 md:right-[8px] bottom-[0px] md:top-[680px] w-[281px] md:w-auto z-[-1]"
        />

        <div className="font-sourGummy flex items-center justify-center gap-5 md:gap-8 py-8">
          <a href="https://littlepepe.com/audit/" target="_blank" rel="noopener noreferrer">
            <button className="bg-[#FEF200] border border-black outline outline-[4px] outline-[#FEF200] px-4 md:px-6 py-1 md:py-2 rounded-full uppercase cursor-pointer text-2xl md:text-3xl">
              audit
            </button>
          </a>

          <a href="https://littlepepe.com/little-pepe-whitepaper.pdf" target="_blank" rel="noopener noreferrer">
            <button className="bg-[#006C28] border border-[#FEF200] text-[#FEF200] outline outline-[3px] outline-[#006C28] px-4 py-1 md:px-6 md:py-2 rounded-full uppercase cursor-pointer text-2xl md:text-3xl">
              Whitepaper
            </button>
          </a>
        </div>

        <div className="max-w-[558px] mt-20 w-full mx-auto text-center flex flex-col items-center border-2 border-[#000000] rounded-lg bg-[#F5F2D0] font-sourGummy px-3 md:px-8 py-4 shadow-[0px_10px_10px_-10px_#000000] z-[999]">
          <img src={logo} alt="logo" />
          <div className="flex items-center justify-between w-full text-2xl font-bold">
            <p>
              Next Stage Price: ${Number((nextPrice / 10 ** 6)).toFixed(5).toLocaleString()}
            </p>
            <div className="bg-[#F4EB82] px-3 py-1.5 rounded-lg border border-black shadow-[0px_10px_10px_-10px_#227C3C]">
              Stage {Number(presaleId)}
            </div>
          </div>
          <div className="-rotate-[12deg] py-8">
            <span className="border-2 border-black px-4 py-1.5 rounded-2xl font-bold bg-[#FFCCBC]">
              1 PEPE = ${Number((currentPrice / 10 ** 6)).toFixed(5).toLocaleString()}
            </span>
          </div>
          <div className="font-sourGummy w-full text-2xl font-bold text-black text-center">
            <p>
              USD Raised: $
              {Number((raisedAmount / 10 ** 6).toFixed(0)).toLocaleString()} /${' '}
              {Number((totalAmount / 10 ** 6).toFixed(0)).toLocaleString()}
            </p>
            <p>
              Tokens Sold:{' '}
              {Number((tokenSoldAmount / 10 ** 18).toFixed(0)).toLocaleString()}{' '}
              /{' '}
              {Number(
                (totalToknesToSell / 10 ** 18).toFixed(0)
              ).toLocaleString()}{' '}
            </p>
            {/* {Number(claimableAmount) > 0 && (
              <p className="mt-2 text-gray-400">
                YOUR HOLD: {Number(claimableAmount).toLocaleString()} LNTL
              </p>
            )} */}
            {/* <p
              className="bg-white text-sm w-full rounded-xl border border-black mt-2  transition-all duration-500"
              style={{ width: progress }}
            >
              <span
                ref={textRef}
                className="absolute text-white text-lg font-bold px-4 whitespace-nowrap"
                style={{
                  left: '50%',
                  transform: `translateX(-50%)`,
                  transition: 'left 0.5s ease-out',
                  textShadow: '1px 1px 5px #000000aa'
                }}
              >
                {(Number(raisedAmount) * 100) / totalAmount} %
              </span>
            </p> */}

            <div className="w-full mt-4 relative">
              <div className="h-6 bg-gray-300 rounded-full overflow-hidden border-2 border-black">
                <div
                  className="h-full flex items-center justify-center transition-all duration-500"
                  style={{
                    width: progress,
                    background:
                      'repeating-linear-gradient(135deg, #F4D03F 0px,rgb(202, 180, 92) 8px, #F7DC6F 8px,rgb(255, 230, 129) 16px)'
                  }}
                >
                  <span
                    ref={textRef}
                    className="absolute text-black text-sm font-bold px-4 whitespace-nowrap"
                    style={{
                      left: '50%',
                      transform: `translateX(-50%)`,
                      transition: 'left 0.5s ease-out',
                      textShadow: '1px 1px 2px #00000050'
                    }}
                  >
                    {((Number(tokenSoldAmount) * 100) / totalToknesToSell).toFixed(2)}%
                  </span>
                </div>
              </div>
              {/* <div style={{ marginTop: '1rem' }}>
                          <div style={{ fontSize: '20px' }}>{`${convert(raisedAmount)} $`} <span className='text-#FFD73C' style={{ fontSize: '12px' }}>Out of</span> {`${totalAmount} $ETH`}</div>
                        </div>
                </div> */}
            </div>

            {/* <p className="pt-4">
              {selectedOpt.title} Balance:{' '}
              {Number(accountBalance) > 0.00001
                ? Number(accountBalance).toFixed(3)
                : '0'}
            </p> */}
          </div>
          <div className="flex items-center justify-between gap-3 py-4">
            {sourceOptions.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  setSelectedOpt(item)
                  setSelectToken(index + 1)
                  if (item.title === 'CARD') {
                    window.open('https://littlepepe.com/how-to-buy/', '_blank')
                  }
                }}
                className={`px-6 py-1 rounded-xl border flex items-center justify-center gap-3 bg-[#EEF0F4] ${item.title === selectedOpt.title
                    ? 'border-black'
                    : 'border-transparent'
                  }`}
                style={{
                  boxShadow:
                    item.title === selectedOpt.title
                      ? `rgba(0, 0, 0, 0.55) 1.95px 2.95px 2.6px`
                      : ''
                }}
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="w-[25px] h-[25px]"
                />
                <span>{item.title}</span>
              </div>
            ))}
          </div>
          {presaleStatus === true ? (
            <>
              <div className="w-full flex flex-col md:flex-row items-center justify-between gap-3">
                <div className="w-full border border-[#1976D2] rounded-lg px-2 py-1 flex items-center justify-start gap-1.5">
                  <input
                    type="number"
                    placeholder="0.0"
                    name="amount"
                    id="amount"
                    onChange={e => setAmount(e.target.value)}
                    value={tokenAmount}
                    className="w-full text-[black]"
                  />
                  <button
                    onClick={setMaxAmount}
                    className="bg-[#F4EB82] px-1 rounded-md border-2 border-[#227C3C] text-[#227C3C] text-sm"
                  >
                    Max
                  </button>
                  <img
                    src={selectedOpt.icon}
                    alt={selectedOpt.title}
                    className="w-[25px] h-[25px]"
                  />
                </div>
                <div className="w-full border border-[#1976D2] rounded-lg px-2 py-1 flex items-center justify-between">
                  <input
                    type="number"
                    name="amount"
                    id="amount"
                    placeholder="0"
                    value={outTokenAmount}
                    readOnly
                  />
                  <img src={favLogo} alt={''} />
                </div>
              </div>
              {Number(tokenAmount) > Number(allowanceAmount) &&
                selectedToken !== 0 ? (
                <div className="flex flex-col items-center w-full">
                  {confirming ? (
                    <>
                      <p className="text-#F87113">Approving</p>
                      <ClipLoader
                        color="#F87113"
                        loading={confirming}
                        size={30}
                      />
                    </>
                  ) : (
                    <button
                      onClick={onTokenAllowance}
                      className="bg-[#F87113] font-bold font-sourGummy w-full uppercase py-2  border-2 border-black rounded-lg"
                    >
                      Allow Tokens First
                    </button>
                  )}
                </div>
              ) : (
                <div className="flex flex-col items-center w-full">
                  {confirming ? (
                    <>
                      <p className="text-white">Confirming...</p>
                      <ClipLoader
                        color="##F87113"
                        loading={confirming}
                        size={30}
                      />
                    </>
                  ) : (
                    isConnected && (
                      <>
                        <button
                          onClick={onTokenDeposit}
                          className="bg-[#F87113] font-bold font-sourGummy w-full uppercase py-2  border-2 border-black rounded-lg"
                        >
                          Buy Token Now!
                        </button>
                        {/* {claimable && claimableAmount > 0 && (
                          <button
                            onClick={onTokenClaim}
                            className="bg-[#F87113] font-bold font-sourGummy w-full uppercase py-2  border-2 border-black rounded-lg"
                          >
                            Claim ({Number(claimableAmount).toFixed(3)} LNTL)
                          </button>
                        )} */}
                      </>
                    )
                  )}
                </div>
              )}
            </>
          ) : presaleStatus === false ? (
            <p className="text-3xl font-extrabold text-black scale-y-60">
              Presale is not live yet
            </p>
          ) : (
            <div className="flex flex-col items-center">
              <p className="text-black">Data Loading...</p>
              <ClipLoader color="#F87113" loading={confirming} size={30} />
            </div>
          )}
          <div className="w-full flex flex-col gap-3 py-3">
            {!isConnected ? (
              <button
                onClick={() => open()}
                className="bg-[#F87113] font-bold font-sourGummy w-full uppercase py-2  border-2 border-black rounded-lg"
              >
                Connect wallet
              </button>
            ) : (
              ''
            )}
            <div className="w-full flex items-center justify-center gap-3">
              <a href="https://littlepepe.com/how-to-buy/" target="_blank" rel="noopener noreferrer"
                className="bg-[#ABE7C0] font-bold font-sourGummy uppercase py-2 w-full  border-2 border-black rounded-lg">
                {/* <button className="bg-[#ABE7C0] font-bold font-sourGummy uppercase py-2 w-full  border-2 border-black rounded-lg"> */}
                How to buy
                {/* </button> */}
              </a>

              <a href="https://littlepepe.com/777k-giveaway/" target="_blank" rel="noopener noreferrer"
                className="bg-[#F69E96] font-bold font-sourGummy uppercase py-2 w-full border-2 border-black rounded-lg">
                {/* <button className="bg-[#F69E96] font-bold font-sourGummy uppercase py-2 w-full border-2 border-black rounded-lg"> */}
                  +777k giveway
                {/* </button> */}
              </a>
            </div>
          </div>
        </div>
      </div>
       <div className="uppercase text-[30px] md:text-[70px] pt-10 pb-2 font-extrabold font-sourGummy leading-tight text-black text-center">
          featured in
       </div>
    </div>
  )
}

export default Hero
